import {createFileRoute, useNavigate} from '@tanstack/react-router';
import {useEffect} from 'react';

import {isDevelopmentEnv} from '~utils/miscUtils';
import {ModelTrainingSearchParams, Route as RouteEnum} from '~utils/routeUtil';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {useIsCurrentModelAutomlEnabled} from '~components/models/model.hooks';
import {ModelTrainingOverview} from '~components/models/training/ModelTrainingOverview';
import {ModelProvider} from 'src/contexts/ModelProvider';

export const Route = createFileRoute('/model/training')({
  component: ModelTrainingPage,
  validateSearch: ModelTrainingSearchParams.validate,
});

function ModelTrainingPage(): JSX.Element | null {
  const {automlEnabled, isLoading} = useIsCurrentModelAutomlEnabled();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !automlEnabled && !isDevelopmentEnv()) {
      navigate({to: RouteEnum.notFound as any});
    }
  }, [automlEnabled, isLoading, navigate]);

  if (isLoading) {
    return null;
  }

  if (!automlEnabled && !isDevelopmentEnv()) {
    return null;
  }

  return (
    <ModelProvider mode='model-pages'>
      <BaseLayout customContentAndFooter showBackButton>
        <ModelTrainingOverview />
      </BaseLayout>
    </ModelProvider>
  );
}
